export enum ModuleName {
    'Employee Setup' = 'Employee Setup',
    'Company Setup' = 'Company Setup',
    'Company Group' = 'Company Group',
    'Salary Advance' = 'Salary Advance',
    'Medical Advance' = 'Medical Advance',
    'Role Module Permission' = 'Role Module Permission',
    'User' = 'User',
    'Employee Privillege Category' = 'Employee Privillege Category',
    'Employee Privillege' = 'Employee Privillege',
    'Medical Advance Report' = 'Medical Advance Report',
    'Salary Advance Report' = 'Salary Advance Report',
    'Salary Advance Bank Submission' = 'Salary Advance Bank Submission',
    // Must match Module.Name in the database exactly — the backend row is id 19, seeded manually.
    'People Operations Dashboard' = 'People Operations Dashboard',
    // Must match Module.Name in the database exactly — seeded manually, see
    // todos/20260915_1536/SPEC.md §Module Permission Provisioning.
    'Salary Advance Summary Report' = 'Salary Advance Summary Report',
    // Must match Module.Name in the database exactly — seeded manually, see
    // todos/20260915_1554/SPEC.md §Module Permission Provisioning.
    'Medical Usage Summary Report' = 'Medical Usage Summary Report',
    // Must match Module.Name in the database exactly — seeded manually (Staging only so far),
    // see todos/20260921_1156/SPEC.md §Auth & permissions.
    'Monthly Invoice Generator' = 'Monthly Invoice Generator',
}
